import { Divider } from "@mui/material";
import styled from "styled-components";

interface IStyledDivider {}

const StyledDivider = styled(Divider)<IStyledDivider>`
    background-color: ${(props) => props.theme.tableHeadCellSortIconHover};
    opacity: 0.3;
`;

export default StyledDivider;
